import React from 'react';


const Kodama = () => {

    return (
        <div className="text-center">
            <img src="/img/fin001-1.jpg" alt="fin" style={{ maxWidth: "90vw", maxHeight: "70vh", height: "auto" }} />
        </div>
    );
}

export default Kodama;
